import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { trackEvent } from "@/utils/tagManagerUtils";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const AutomatizacionGoogleAdsES = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    trackEvent("page_view", { path: "/es/automatizacion-google-ads" });
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>Herramienta de Automatización de Google Ads | Upfixe</title>
        <meta
          name="description"
          content="Upfixe es la herramienta de automatización de Google Ads definitiva. Ahorre horas de trabajo manual y deje que la IA optimice sus campañas."
        />
        <meta
          name="keywords"
          content="automatización google ads, herramienta google ads, ia google ads, optimización ppc"
        />
        <link rel="canonical" href="https://upfixe.com/es/automatizacion-google-ads" />
      </Helmet>

      <Header />

      <main className="flex-grow pt-24 pb-16">
        <section className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center mb-20">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-gray-900 mb-6">
            La herramienta de automatización de <span className="text-primary">Google Ads más inteligente</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-10">
            Deje de perder horas en la investigación manual de palabras clave y ajustes de ofertas.
            Upfixe automatiza todo su flujo de trabajo en Google Ads.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button asChild size="lg" className="text-lg px-8 py-6 rounded-full">
              <a href="https://app.upfixe.com/signup">
                Prueba Gratis <ArrowRight className="ml-2 h-5 w-5" />
              </a>
            </Button>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default AutomatizacionGoogleAdsES;
